import { render, staticRenderFns } from "./FirstTimeSelect.vue?vue&type=template&id=f0618830&scoped=true"
import script from "./FirstTimeSelect.vue?vue&type=script&lang=js"
export * from "./FirstTimeSelect.vue?vue&type=script&lang=js"
import style0 from "./FirstTimeSelect.vue?vue&type=style&index=0&id=f0618830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0618830",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationStreamListTheList: require('/builds/gb-developers/geekbrains-client/components/pages/education/StreamList/TheList.vue').default})
